var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('h2',[_vm._v("PAGE NOT FOUND")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }